export const LICENSE_COMMERCIAL = 'COMMERCIAL';
export const LICENSE_ACADEMIC = 'ACADEMIC';
export const LICENSE_STARTER = 'STARTER';
export const LICENSE_OPENSOURCE = 'OPEN_SOURCE';
export const LICENSE_COMMUNITY = 'COMMUNITY';

export type LicenseType = 'COMMERCIAL' | 'ACADEMIC' | 'STARTER' | 'OPEN_SOURCE' | 'COMMUNITY';
